import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cc from 'classnames';
import { AuthContext } from '@ryanar/react-auth-provider';
import noop from 'utils/noop';
import { WarningModal } from 'components/modals';
import api from 'api/api';
import styles from './SideMenuItem.module.css';

interface ISideMenuItem {
  icon: string;
  iconAlt: string;
  name: string;
  link?: string;
  className?: string;
}

const SideMenuItem = ({ icon, iconAlt, name, link, className }: ISideMenuItem) => {
  const [showLogOut, setShowLogOut] = useState(false);

  const { setAuthenticated } = React.useContext(AuthContext);

  const onClose = () => setShowLogOut(false);
  const { pathname } = useLocation();
  const isActiveRoot = pathname.includes(name || 'none');

  const onLogOut = () => {
    api.post('/customer/logout', {}, true, false).finally(() => {
      setAuthenticated(false);
      onClose();
    });
  };

  const content = (
    <div
      className={cc(styles.item, className, { [styles.activeRoot]: isActiveRoot })}
      onClick={() => setShowLogOut(true)}
      onKeyPress={noop}
      role="button"
      tabIndex={0}
    >
      <img src={icon} alt={iconAlt} className={styles.itemIcon} />
      <span className={styles.itemName}>{name}</span>
    </div>
  );

  return link ? (
    <NavLink activeClassName={cc(styles.activeLink)} to={link}>
      {content}
    </NavLink>
  ) : (
    <>
      {content}
      <WarningModal open={showLogOut} onClose={onClose} submitName="Log Out" onSubmit={onLogOut} noIcon>
        Are you sure you want to log out?
      </WarningModal>
    </>
  );
};

export default SideMenuItem;
